module.exports = __webpack_public_path__ + "media/extra_parking.bc6eea2a.svg";